import { render } from "./webSpeech.vue?vue&type=template&id=755a809e&scoped=true"
import script from "./webSpeech.vue?vue&type=script&lang=js"
export * from "./webSpeech.vue?vue&type=script&lang=js"

import "./webSpeech.vue?vue&type=style&index=0&id=755a809e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755a809e"]])

export default __exports__